._buttons_1am0g_1 {
  padding: 0 12px 8px 0; }
